import { all, takeLatest } from "redux-saga/effects";
import { SAVE_LOGIN_STARTED } from "../actions/Login";
import { SAVE_TOKEN_STARTED } from "../actions/Token";
import { SAVE_USER_STARTED, GET_USER_STARTED, UPDATE_STATUS_STARTED } from "../actions/CreateUser";
import { SAVE_REPORT_STARTED, GET_REPORT_STARTED } from "../actions/Report";
import { GET_RCREPORTS_STARTED } from "../actions/Rcreports";
import { GET_COMMONTYPE_STARTED, GETALL_COMMONTYPE_STARTED } from "../actions/Commontype";
import { SAVE_JOBSCHEDULE_STARTED, DELETE_JOBSCHEDULE_STARTED, GET_JOBSCHEDULE_STARTED } from "../actions/JobSchedule";
import { GET_ROLE_STARTED } from "../actions/Role";

import { GET_PASSWORDPOLICY_STARTED, GET_ALLPASSWORDPOLICY_STARTED, SAVE_PASSWORDPOLICY_STARTED } from "../actions/Passwordpolicy";

import { GET_COMMONDETAILS_STARTED, SAVE_COMMONDETAILS_STARTED } from "../actions/Commondetails";

import { saveReport, getReportsList } from "./Report";
import { saveLogin } from "./Login";
import { saveToken } from "./Token";
import { saveNewUser, getUsersList, updateStatus } from "./CreateUser";
import { getSESSION } from "./Session";
import { getCOMMONTYPE, getAllCOMMONTYPE } from "./Commontype";
import { saveJobschedule, deleteJobschedule, getJobschedule } from "./JobSchedule";
import { getRolesByTenant } from "./Role";

import { getpasswordpolicies, getallpasswordpolicies, savepasswordpolicies } from "./Passwordpolicy";

import { getcommondetails, savecommondetails } from "./Commondetails";

import { saveSession, SAVE_SESSION_STARTED } from "../actions/Session"
import { GET_SESSION_STARTED } from "../actions/Session"
import { SAVE_AAROLES_STARTED, DELETE_AAROLES_STARTED, GET_AAROLES_STARTED } from "../actions/Aaroles";
import { SAVE_AAROLESPERMISSION_STARTED, DELETE_AAROLESPERMISSION_STARTED, GET_AAROLESPERMISSION_STARTED } from "../actions/Aarolespermission";
import { SAVE_AAPERMISSIONS_STARTED, DELETE_AAPERMISSIONS_STARTED, GET_AAPERMISSIONS_STARTED } from "../actions/Aapermissions";
import { getAaroles, deleteAaroles, saveAaroles } from "./Aaroles";
import { getAapermissions, deleteAapermissions, saveAapermissions } from "./Aapermissions";
import { getAarolespermission, deleteAarolespermission, saveAarolespermission } from "./Aarolespermission";
import { SAVE_PASSWORDRESET_STARTED, GET_ACTCODEPASSWORD_STARTED } from '../actions/Passwordreset';
import { GET_PASSWORDHISTORY_STARTED } from '../actions/Passwordhistory';
import { SAVE_NEWPASSWORDRESET_STARTED } from '../actions/Newpasswordreset';
import { SAVE_FORGOTPASSWORD_STARTED, SAVE_FORGOTUSERNAME_STARTED } from '../actions/Forgotpassword';
import { saveForgotpassword, saveForgotUsername } from "./Forgotpassword";

import { getRCREPORTS } from "./Rcreports";
import { savenewPassword, getactcodepassword } from "./Passwordreset";
import { getpasswordhistory } from "./Passwordhistory";
import { savenewresetPassword } from "./Newpasswordreset";
import { GET_COMMONCATEGORY_STARTED } from "../actions/Commoncategory";
import { getCOMMONCATEGORY } from "./Commoncategory"
import {
  SAVE_COMPANYADDINFO_STARTED, ADD_COMPANYADDINFO_STARTED, GET_COMPANYADDINFO_STARTED, UPDATE_CORPORATE_STARTED
} from "../actions/AddCorporate";
import {
  SENT_CREATEEMPLOYEREMAIL_STARTED, SENT_CREATEEMPLOYEEEMAIL_STARTED, SENT_CREATECASEEMAIL_STARTED, SENT_EMPLOYMENTCREATION_STARTED
} from "../actions/AddEmail";

import { GET_EVENTFLOW_STARTED, SAVE_EVENTFLOW_STARTED, UPDATE_EVENTFLOW_STARTED } from "../actions/EventDetails";
import {
  geteventFlowInitiation, eventFlowInitiationCreate, eventFlowInitiationUpdate
} from "./EventDetails";

import {
  UPDATE_LAWFIRM_STARTED, GET_LAWFIRM_STARTED, ADD_LAWFIRM_STARTED,
  UPDATE_ATTORNEY_STARTED, GET_ATTORNEY_STARTED, ADD_ATTORNEY_STARTED,
  UPDATE_LF_CORPORATE_STARTED, GET_LF_CORPORATE_STARTED, ADD_LF_CORPORATE_STARTED,
  GET_LAWFIRMCASEFLOW_STARTED, GET_ALLLAWFIRM_STARTED
} from "../actions/LawFirm";
import {
  getallCompanyAdditionalDetails, saveCompanyAdditionalDetails, addCompanyDetails, updateCorporateDetail
} from "./AddCorporate";
import { employerSetupEmail, sendCaseCreationEmail, employeeAccountCreationEmail, employmentCreation } from "./AddEmail";
import {
  getAllLawFirmDetails, updateLawFirmDetails, addLawFirmDetails,
  getAllAttorneyDetails, updateAttorneyDetails, addAttorneyDetails,
  getAllCorporateDetails, updateCorporateDetails, addCorporateDetails,
  getAllCaseflowsByLawfirmId, getAllLawFirmDetail
} from "./LawFirm";

import {
  SAVE_ATTORNEYINFO_STARTED, GET_ATTORNEYINFO_STARTED, UPDATE_ATTORNEYDETAILS_STARTED,
  SAVE_G28FORM_STARTED, GET_G28FORM_STARTED, UPDATE_G28FORM_STARTED, GENERATE_G28FORM_STARTED
} from "../actions/AddAttorney";
import {
  getallAttorneyDetails, saveAttorneyDetails, updateAttorneyDetailsInput,
  getCaseFlowG28ByCaseId, createCaseFlowg28, updateCaseFlowg28, g28PdfGenerationNew
} from "./AddAttorney";
import {
  SAVE_EMPTY_CASE_STARTED, UPDATE_EMPTY_CASE_STARTED, SAVE_CASEFLOW_STARTED, UPDATE_CASEFLOW_STARTED
  , SAVE_WORKFLOW_STARTED, UPDATE_WORKFLOW_STARTED, SAVE_EMP_BIOGRAPHICS_STARTED, UPDATE_EMP_BIOGRAPHICS_STARTED,
  SAVE_H1BFORMS_STARTED, UPDATE_H1BFORMS_STARTED, GET_ALLCASEFLOW_STARTED, GET_CASEID_STARTED, GET_CASEFLOW_INITIATION_STARTED
  , GET_EMPLOYEE_BIOG_STARTED, GET_H1BFORMS_STARTED, SAVEPDF_H1BFORMS_STARTED, UPLOADFILE_CASEFLOW_STARTED,
  UPLOADFILE_H1BFORMS_STARTED, GET_CASEDETAILS_STARTED, GET_ATTORNEYG28DETAILS_STARTED, SAVE_ATTORNEYG28DETAILS_STARTED, CREATE_H1BG28FORMS_STARTED,
  SAVE_I907FORM_STARTED, UPDATE_I907FORM_STARTED, GET_I907FORM_STARTED, CREATE_I907FORMS_STARTED, GET_EMPLOYER_LIST_STARTED, GET_PETITION_APPROVED_STARTED
  , CREATE_EMPLOYEMENT_STARTED, UPDATE_EMPLOYEMENT_STARTED, UPDATE_ALLEMPLOYEMENT_STARTED,
  GET_PLAN_ALLCASEFLOW_STARTED
} from "../actions/VisaCareCase";


import {
  caseflowCreateEmptyCase, caseflowUpdateCase, caseflowInitiationCreate, caseflowInitiationUpdate,
  workflowCreate, workflowUpdateWorkflows, employeeBiographicsUpdate, employeeBiographicsCreate,
  h1bformsCreate, h1bformsUpdate, getAllCaseflows, getAllCaseflow, getCaseflowInitiationDetails,
  getEmployeeBiographicsDetails, getH1bformsDetails, h1bformsPdfSubmit, uploadFileCaseFlow, uploadFileH1BPetitioner,
  getCaseDetails, getAttorneyG28Details, generateG28Pdf, h1bg28formsCreate,
  generateI907Pdf, updateI907Form, createI907Form, getI907FormDetails, getAllCompanyProfileDetails, getCaseDetailsByPetitionApproved
  , updateEmployeement, createEmployeement, updateAllEmployeement, getCaseflowsByPlanCompanyautoIdAndfilingUserName
} from "./VisaCareCase";

import {
  SAVE_I130_BIOGRAPHICS_STARTED,
  UPDATE_I130_BIOGRAPHICS_STARTED,
  GET_I130_BIOGRAPHICS_STARTED,

  SAVE_I130FORMS_STARTED,
  UPDATE_I130FORMS_STARTED,
  GET_I130FORMS_STARTED,
  SAVEPDF_I130FORMS_STARTED,

  SAVE_I130AFORMS_STARTED,
  UPDATE_I130AFORMS_STARTED,
  GET_I130AFORMS_STARTED,
  SAVEPDF_I130AFORMS_STARTED,

  SAVE_I131FORMS_STARTED,
  UPDATE_I131FORMS_STARTED,
  GET_I131FORMS_STARTED,
  SAVEPDF_I131FORMS_STARTED,


  SAVE_I864FORMS_STARTED,
  UPDATE_I864FORMS_STARTED,
  GET_I864FORMS_STARTED,
  SAVEPDF_I864FORMS_STARTED,

  SAVE_I485FORMS_STARTED,
  UPDATE_I485FORMS_STARTED,
  GET_I485FORMS_STARTED,
  SAVEPDF_I485FORMS_STARTED

} from "../actions/I130Case";
import {
  biographicsCreate, biographicsUpdate, getBiographicsDetails,
  i130formsCreate, i130formsUpdate, getI130formsDetails, i130FormPdfData,
  i130AformsCreate, i130AformsUpdate, getI130AformsDetails, i130AFormPdfData,
  i131formsCreate, i131formsUpdate, getI131formsDetails, i131FormPdfData,
  i864formsCreate, i864formsUpdate, getI864formsDetails, i864FormPdfData,
  i485formsCreate, i485formsUpdate, getI485formsDetails, i485FormPdfData,
} from "./I130Case";
import {
  SAVE_H4FORMS_STARTED, UPDATE_H4FORMS_STARTED, GET_H4FORMS_STARTED,
  SAVE_H4FORMSTRACKING_STARTED, UPDATE_H4FORMSTRACKING_STARTED, GET_H4FORMSTRACKING_STARTED,
  GET_H4FORMS539APDF_STARTED

} from "../actions/VisaCareH4Case";

import {
  createH4PetitionerDetails, updateH4PetitionerDetails, getH4PetitionerDetails,
  caseflowH4CaseTrackingCreate, caseflowH4CaseTrackingUpdate, getCaseflowH4CaseTracking, h4FormPdfSubmit
} from "./VisaCareH4Case";

import { edaCaseQuestion, createEADPetition, updateEADPetition, getEADPetition, eadPdfFormSubmit } from "./VisaCareEADCase";
import { SAVE_EAD_STARTED, GET_EADPETITION_STARTED, CREATE_EADPETITION_STARTED, UPDATE_EADPETITION_STARTED, SAVE_EADFORMSUBMIT_STARTED } from "../actions/VisaCareEADCase";



import { GET_EMPLOYEEINFO_STARTED } from "../actions/Manageuser";
import { getAllEmployeeInfoDetails } from "./Manageuser";

import { GET_PDFINFO_STARTED } from "../actions/testPdfViewer";
import { getPdfView } from "./testPdfViewer";
import {
  CREATE_STRIPECUSTOMER_STARTED, CREATE_SUBCRIPTION_STARTED, GETALL_SUBCRIPTION_STARTED
  , CREATE_FREQUENCY_STARTED, GETALL_FREQUENCY_STARTED, CREATE_COMPANY_DISCOUNT_STARTED
} from "../actions/StripePayment"
import { createStripeCustomer, createFrequency, getAllFrequencyDetails, saveSubscription, getSubscriptionList, createCompanyDiscount } from "./StripePayment";

import { SAVE_EVENT_STARTED, GET_EVENT_STARTED, UPDATE_EVENT_STARTED } from "../actions/UpEvent";
import { comingEvents, getcomingEvents, updatecomingEvents } from "./UpEvent";

import { SAVE_DOCUMENTCASE_STARTED, UPDATE_DOCUMENTCASE_STARTED, GET_ALLDOCUMENTCASE_STARTED, GET_ALLDOCUMENTCASE_BYID_STARTED, GET_ALLDOCUMENTCASE_BYUSER_STARTED } from "../actions/DocumentCase";
import { documentCaseCreate, documentCaseUpdate, getAllDocumentCaseflowsById, getAllDocumentCaseflows, getAllDocumentCaseflowsByUserId } from "./DocumetCase";

import { SAVE_I140FORMS_STARTED, UPDATE_I140FORMS_STARTED, GET_I140FORMS_STARTED, SAVEPDF_I140FORMS_STARTED } from "../actions/VisaCareI140Case";
import { i140formsCreate, i140formsUpdate, getI140formsDetails, i140FormPdfSubmit } from "./VisaCareI140Case";
import { CREATE_LCAPAF_STARTED, UPDATE_LCAPAF_STARTED, GETALL_LCAPAF_STARTED, GET_LCAPAFBYCHILDCASEID_STARTED, GET_LCAPAFBYCOMPANYID_STARTED, GET_LCAPAFBYID_STARTED, GET_LCAPAFBYLISTCASEID_STARTED } from "../actions/VisacareLCAPAFData";
import { createLCAPAFData, updateLCAPAFData, getAllLCAPAFData, getLCAPAFByChildCaseId, getLCAPAFByCompanyId, getLCAPAFById, getLCAPAFByListCaseId } from "./visaCareLCAPAFData";
export default function* rootSaga() {
  yield all([


    takeLatest(SAVE_LOGIN_STARTED, saveLogin),
    takeLatest(SAVE_TOKEN_STARTED, saveToken),
    takeLatest(SAVE_USER_STARTED, saveNewUser),
    takeLatest(SAVE_REPORT_STARTED, saveReport),
    takeLatest(SAVE_JOBSCHEDULE_STARTED, saveJobschedule),
    takeLatest(GET_USER_STARTED, getUsersList),
    takeLatest(GET_REPORT_STARTED, getReportsList),
    takeLatest(GET_ROLE_STARTED, getRolesByTenant),
    takeLatest(GET_JOBSCHEDULE_STARTED, getJobschedule),
    takeLatest(DELETE_JOBSCHEDULE_STARTED, deleteJobschedule),
    takeLatest(GET_PASSWORDPOLICY_STARTED, getpasswordpolicies),
    takeLatest(GET_ALLPASSWORDPOLICY_STARTED, getallpasswordpolicies),
    takeLatest(SAVE_PASSWORDPOLICY_STARTED, savepasswordpolicies),
    takeLatest(GET_COMMONDETAILS_STARTED, getcommondetails),
    takeLatest(SAVE_COMMONDETAILS_STARTED, savecommondetails),
    takeLatest(GET_AAROLES_STARTED, getAaroles),
    takeLatest(SAVE_AAROLES_STARTED, saveAaroles),
    takeLatest(DELETE_AAROLES_STARTED, deleteAaroles),
    takeLatest(GET_AAROLESPERMISSION_STARTED, getAarolespermission),
    takeLatest(SAVE_AAROLESPERMISSION_STARTED, saveAarolespermission),
    takeLatest(DELETE_AAROLESPERMISSION_STARTED, deleteAarolespermission),
    takeLatest(GET_AAPERMISSIONS_STARTED, getAapermissions),
    takeLatest(SAVE_AAPERMISSIONS_STARTED, saveAapermissions),
    takeLatest(DELETE_AAPERMISSIONS_STARTED, deleteAapermissions),
    takeLatest(GET_ACTCODEPASSWORD_STARTED, getactcodepassword),
    takeLatest(GET_PASSWORDHISTORY_STARTED, getpasswordhistory),
    takeLatest(SAVE_PASSWORDRESET_STARTED, savenewPassword),
    takeLatest(SAVE_NEWPASSWORDRESET_STARTED, savenewresetPassword),
    takeLatest(SAVE_FORGOTPASSWORD_STARTED, saveForgotpassword),
    takeLatest(SAVE_FORGOTUSERNAME_STARTED, saveForgotUsername),


    takeLatest(GET_RCREPORTS_STARTED, getRCREPORTS),
    takeLatest(GET_COMMONTYPE_STARTED, getCOMMONTYPE),
    takeLatest(GETALL_COMMONTYPE_STARTED, getAllCOMMONTYPE),
    takeLatest(GET_COMMONCATEGORY_STARTED, getCOMMONCATEGORY),
    takeLatest(SAVE_SESSION_STARTED, saveSession),
    takeLatest(GET_SESSION_STARTED, getSESSION),
    takeLatest(GET_COMPANYADDINFO_STARTED, getallCompanyAdditionalDetails),
    takeLatest(SAVE_COMPANYADDINFO_STARTED, saveCompanyAdditionalDetails),
    takeLatest(ADD_COMPANYADDINFO_STARTED, addCompanyDetails),
    takeLatest(SENT_CREATEEMPLOYEREMAIL_STARTED, employerSetupEmail),
    takeLatest(SENT_CREATEEMPLOYEEEMAIL_STARTED, employeeAccountCreationEmail),
    takeLatest(SENT_CREATECASEEMAIL_STARTED, sendCaseCreationEmail),

    takeLatest(GET_LAWFIRM_STARTED, getAllLawFirmDetails),
    takeLatest(UPDATE_LAWFIRM_STARTED, updateLawFirmDetails),
    takeLatest(ADD_LAWFIRM_STARTED, addLawFirmDetails),
    takeLatest(GET_ALLLAWFIRM_STARTED, getAllLawFirmDetail),
    takeLatest(GET_ATTORNEY_STARTED, getAllAttorneyDetails),
    takeLatest(UPDATE_ATTORNEY_STARTED, updateAttorneyDetails),
    takeLatest(ADD_ATTORNEY_STARTED, addAttorneyDetails),

    takeLatest(GET_LF_CORPORATE_STARTED, getAllCorporateDetails),
    takeLatest(UPDATE_LF_CORPORATE_STARTED, updateCorporateDetails),
    takeLatest(ADD_LF_CORPORATE_STARTED, addCorporateDetails),

    takeLatest(GET_LAWFIRMCASEFLOW_STARTED, getAllCaseflowsByLawfirmId),


    takeLatest(UPDATE_ATTORNEYDETAILS_STARTED, updateAttorneyDetailsInput),
    takeLatest(GET_ATTORNEYINFO_STARTED, getallAttorneyDetails),
    takeLatest(SAVE_ATTORNEYINFO_STARTED, saveAttorneyDetails),

    takeLatest(UPDATE_G28FORM_STARTED, updateCaseFlowg28),
    takeLatest(GET_G28FORM_STARTED, getCaseFlowG28ByCaseId),
    takeLatest(SAVE_G28FORM_STARTED, createCaseFlowg28),
    takeLatest(GENERATE_G28FORM_STARTED, g28PdfGenerationNew),
    takeLatest(SAVE_EMPTY_CASE_STARTED, caseflowCreateEmptyCase),
    takeLatest(UPDATE_EMPTY_CASE_STARTED, caseflowUpdateCase),
    takeLatest(SAVE_CASEFLOW_STARTED, caseflowInitiationCreate),
    takeLatest(UPDATE_CASEFLOW_STARTED, caseflowInitiationUpdate),
    takeLatest(SAVE_WORKFLOW_STARTED, workflowCreate),
    takeLatest(UPDATE_WORKFLOW_STARTED, workflowUpdateWorkflows),
    takeLatest(SAVE_EMP_BIOGRAPHICS_STARTED, employeeBiographicsCreate),
    takeLatest(UPDATE_EMP_BIOGRAPHICS_STARTED, employeeBiographicsUpdate),
    takeLatest(SAVE_H1BFORMS_STARTED, h1bformsCreate),
    takeLatest(UPDATE_H1BFORMS_STARTED, h1bformsUpdate),
    takeLatest(GET_EMPLOYEEINFO_STARTED, getAllEmployeeInfoDetails),
    takeLatest(GET_ALLCASEFLOW_STARTED, getAllCaseflows),
    takeLatest(GET_CASEID_STARTED, getAllCaseflow),
    takeLatest(GET_PDFINFO_STARTED, getPdfView),
    takeLatest(GET_CASEFLOW_INITIATION_STARTED, getCaseflowInitiationDetails),
    takeLatest(GET_EMPLOYEE_BIOG_STARTED, getEmployeeBiographicsDetails),
    takeLatest(GET_H1BFORMS_STARTED, getH1bformsDetails),
    takeLatest(SAVEPDF_H1BFORMS_STARTED, h1bformsPdfSubmit),
    takeLatest(UPLOADFILE_CASEFLOW_STARTED, uploadFileCaseFlow),
    takeLatest(UPLOADFILE_H1BFORMS_STARTED, uploadFileH1BPetitioner),
    takeLatest(SAVE_H4FORMS_STARTED, createH4PetitionerDetails),
    takeLatest(UPDATE_H4FORMS_STARTED, updateH4PetitionerDetails),
    takeLatest(GET_H4FORMS_STARTED, getH4PetitionerDetails),
    takeLatest(GET_CASEDETAILS_STARTED, getCaseDetails),
    takeLatest(GET_ATTORNEYG28DETAILS_STARTED, getAttorneyG28Details),
    takeLatest(SAVE_ATTORNEYG28DETAILS_STARTED, h1bg28formsCreate),
    takeLatest(CREATE_H1BG28FORMS_STARTED, generateG28Pdf),

    takeLatest(GET_EVENTFLOW_STARTED, geteventFlowInitiation),
    takeLatest(SAVE_EVENTFLOW_STARTED, eventFlowInitiationCreate),
    takeLatest(UPDATE_EVENTFLOW_STARTED, eventFlowInitiationUpdate),

    takeLatest(SAVE_H4FORMSTRACKING_STARTED, caseflowH4CaseTrackingCreate),
    takeLatest(UPDATE_H4FORMSTRACKING_STARTED, caseflowH4CaseTrackingUpdate),
    takeLatest(GET_H4FORMSTRACKING_STARTED, getCaseflowH4CaseTracking),
    takeLatest(GET_H4FORMS539APDF_STARTED, h4FormPdfSubmit),

    takeLatest(GET_I907FORM_STARTED, getI907FormDetails),
    takeLatest(SAVE_I907FORM_STARTED, createI907Form),
    takeLatest(UPDATE_I907FORM_STARTED, updateI907Form),
    takeLatest(CREATE_I907FORMS_STARTED, generateI907Pdf),
    takeLatest(GET_EMPLOYER_LIST_STARTED, getAllCompanyProfileDetails),

    takeLatest(UPDATE_STATUS_STARTED, updateStatus),

    takeLatest(CREATE_STRIPECUSTOMER_STARTED, createStripeCustomer),

    takeLatest(CREATE_SUBCRIPTION_STARTED, saveSubscription),
    takeLatest(GETALL_SUBCRIPTION_STARTED, getSubscriptionList),
    takeLatest(CREATE_FREQUENCY_STARTED, createFrequency),
    takeLatest(GETALL_FREQUENCY_STARTED, getAllFrequencyDetails),
    takeLatest(CREATE_COMPANY_DISCOUNT_STARTED, createCompanyDiscount),
    takeLatest(UPDATE_CORPORATE_STARTED, updateCorporateDetail),
    takeLatest(GET_PETITION_APPROVED_STARTED, getCaseDetailsByPetitionApproved),

    takeLatest(SAVE_EVENT_STARTED, comingEvents),
    takeLatest(GET_EVENT_STARTED, getcomingEvents),
    takeLatest(UPDATE_EVENT_STARTED, updatecomingEvents),
    takeLatest(UPDATE_EMPLOYEMENT_STARTED, updateEmployeement),
    takeLatest(CREATE_EMPLOYEMENT_STARTED, createEmployeement),
    takeLatest(SAVE_EAD_STARTED, edaCaseQuestion),
    takeLatest(UPDATE_ALLEMPLOYEMENT_STARTED, updateAllEmployeement),
    takeLatest(UPDATE_EADPETITION_STARTED, updateEADPetition),
    takeLatest(CREATE_EADPETITION_STARTED, createEADPetition),
    takeLatest(SENT_EMPLOYMENTCREATION_STARTED, employmentCreation),
    takeLatest(GET_EADPETITION_STARTED, getEADPetition),
    takeLatest(SAVE_EADFORMSUBMIT_STARTED, eadPdfFormSubmit),
    takeLatest(SAVE_DOCUMENTCASE_STARTED, documentCaseCreate),
    takeLatest(UPDATE_DOCUMENTCASE_STARTED, documentCaseUpdate),
    takeLatest(GET_ALLDOCUMENTCASE_STARTED, getAllDocumentCaseflows),
    takeLatest(GET_ALLDOCUMENTCASE_BYID_STARTED, getAllDocumentCaseflowsById),
    takeLatest(GET_ALLDOCUMENTCASE_BYUSER_STARTED, getAllDocumentCaseflowsByUserId),
    takeLatest(SAVE_I140FORMS_STARTED, i140formsCreate),
    takeLatest(UPDATE_I140FORMS_STARTED, i140formsUpdate),
    takeLatest(GET_I140FORMS_STARTED, getI140formsDetails),
    takeLatest(SAVEPDF_I140FORMS_STARTED, i140FormPdfSubmit),


    takeLatest(SAVE_I130_BIOGRAPHICS_STARTED, biographicsCreate),
    takeLatest(UPDATE_I130_BIOGRAPHICS_STARTED, biographicsUpdate),
    takeLatest(GET_I130_BIOGRAPHICS_STARTED, getBiographicsDetails),


    takeLatest(SAVE_I130FORMS_STARTED, i130formsCreate),
    takeLatest(UPDATE_I130FORMS_STARTED, i130formsUpdate),
    takeLatest(GET_I130FORMS_STARTED, getI130formsDetails),
    takeLatest(SAVEPDF_I130FORMS_STARTED, i130FormPdfData),

    takeLatest(SAVE_I130AFORMS_STARTED, i130AformsCreate),
    takeLatest(UPDATE_I130AFORMS_STARTED, i130AformsUpdate),
    takeLatest(GET_I130AFORMS_STARTED, getI130AformsDetails),
    takeLatest(SAVEPDF_I130AFORMS_STARTED, i130AFormPdfData),


    takeLatest(SAVE_I131FORMS_STARTED, i131formsCreate),
    takeLatest(UPDATE_I131FORMS_STARTED, i131formsUpdate),
    takeLatest(GET_I131FORMS_STARTED, getI131formsDetails),
    takeLatest(SAVEPDF_I131FORMS_STARTED, i131FormPdfData),

    takeLatest(SAVE_I864FORMS_STARTED, i864formsCreate),
    takeLatest(UPDATE_I864FORMS_STARTED, i864formsUpdate),
    takeLatest(GET_I864FORMS_STARTED, getI864formsDetails),
    takeLatest(SAVEPDF_I864FORMS_STARTED, i864FormPdfData),

    takeLatest(SAVE_I485FORMS_STARTED, i485formsCreate),
    takeLatest(UPDATE_I485FORMS_STARTED, i485formsUpdate),
    takeLatest(GET_I485FORMS_STARTED, getI485formsDetails),
    takeLatest(SAVEPDF_I485FORMS_STARTED, i485FormPdfData),

    takeLatest(GET_PLAN_ALLCASEFLOW_STARTED, getCaseflowsByPlanCompanyautoIdAndfilingUserName),

    takeLatest(GETALL_LCAPAF_STARTED, getAllLCAPAFData),
    takeLatest(GET_LCAPAFBYCHILDCASEID_STARTED, getLCAPAFByChildCaseId),
    takeLatest(GET_LCAPAFBYCOMPANYID_STARTED, getLCAPAFByCompanyId),
    takeLatest(GET_LCAPAFBYID_STARTED, getLCAPAFById),
    takeLatest(GET_LCAPAFBYLISTCASEID_STARTED, getLCAPAFByListCaseId),
    takeLatest(CREATE_LCAPAF_STARTED, createLCAPAFData),
    takeLatest(UPDATE_LCAPAF_STARTED, updateLCAPAFData)
  ]);
}
